'use client';

import { c as _c } from "react/compiler-runtime";
import { AlertDialog, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, Input } from '@repo/ui/components';
export const ManualCopyCustomerSetupLinkDialog = t0 => {
  const $ = _c(14);
  const {
    onClose,
    url
  } = t0;
  let t1;
  if ($[0] !== onClose) {
    t1 = open => open ? undefined : onClose();
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = Boolean(url);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <AlertDialogHeader data-sentry-element="AlertDialogHeader" data-sentry-source-file="manual-copy-dialog.tsx"><AlertDialogTitle data-sentry-element="AlertDialogTitle" data-sentry-source-file="manual-copy-dialog.tsx">Copy customer setup link</AlertDialogTitle><AlertDialogDescription data-sentry-element="AlertDialogDescription" data-sentry-source-file="manual-copy-dialog.tsx">Your browser could not copy the link automatically. Select and copy the full link below.</AlertDialogDescription></AlertDialogHeader>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = url ?? "";
  let t5;
  if ($[3] !== t4) {
    t5 = <Input aria-label="Customer setup link" onFocus={_temp} readOnly={true} value={t4} data-sentry-element="Input" data-sentry-source-file="manual-copy-dialog.tsx" />;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== onClose) {
    t6 = <AlertDialogFooter data-sentry-element="AlertDialogFooter" data-sentry-source-file="manual-copy-dialog.tsx"><AlertDialogCancel onClick={onClose} data-sentry-element="AlertDialogCancel" data-sentry-source-file="manual-copy-dialog.tsx">Done</AlertDialogCancel></AlertDialogFooter>;
    $[5] = onClose;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t5 || $[8] !== t6) {
    t7 = <AlertDialogContent data-sentry-element="AlertDialogContent" data-sentry-source-file="manual-copy-dialog.tsx">{t3}{t5}{t6}</AlertDialogContent>;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t7) {
    t8 = <AlertDialog onOpenChange={t1} open={t2} data-sentry-element="AlertDialog" data-sentry-component="ManualCopyCustomerSetupLinkDialog" data-sentry-source-file="manual-copy-dialog.tsx">{t7}</AlertDialog>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
};
function _temp(event) {
  return event.currentTarget.select();
}